import React from 'react';
import Icon from '../../Icon';
import Tooltip from '../../Tooltip';
import './InfoTooltip.less';

const InfoTooltip = ({ icon = 'info-circle', value }) => {
    if (!value) return null;
    return (
        <div className='info-tooltip-container'>
            <Tooltip title={value}>
                <div className='info-tooltip'>
                    <Icon value={icon} />
                </div>
            </Tooltip>
        </div>
    );
};

export default InfoTooltip;
